<nav class="navbar navbar-expand-sm navbar-light bg-light navbar-top-header">
  <div class="d-flex">
    <div class="ham-icon ml-3">
      <button class="navbar-toggler ham-menu-icon" type="button" (click)="addClassToBodyForResponsiveMenu()" id="menuBtn">
        <span class="navbar-toggler-icon"></span>
      </button>
    </div>
  </div>
  <div class="w-100 d-flex justify-content-end">
    <div class="navbar-nav dropdown justify-content-end">
      <a
        class="nav-link dropdown-toggle"
        id="navbarDropdown"
        title="Profile"
        role="button"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
      >
        <img *ngIf="userService.img" class="rounded-circle header-avatar" [src]="userService.img" />
        <span class="circle-sm" *ngIf="!userService.img">{{ userService?.userData?.name?.toUpperCase()?.substring(0, 2) ?? '' }}</span>
      </a>
      <div class="dropdown-menu dropdown-menu-right settings-dropdown" aria-labelledby="navbarDropdown">
        <div class="dropdown-item default">
          <div class="row">
            <div class="col-3 avatar-section">
              <img *ngIf="userService.img" class="rounded-circle header-avatar-bigger" id="settings-avatar" [src]="userService.img" />
              <span class="circle-md" *ngIf="!userService.img">{{ userService?.userData?.name?.toUpperCase()?.substring(0, 2) ?? '' }}</span>
            </div>
            <div class="col-8">
              <table>
                <tr>
                  <td class="user-title-font username-email-section">{{ userService.userData.name }}</td>
                </tr>
                <tr>
                  <td class="user-details-font username-email-section">{{ userService.userData.email }}</td>
                </tr>
              </table>
            </div>
          </div>
        </div>

        <div class="divider"></div>
        <div class="dropdown-item sign-out default default-font" (click)="logout()">Sign Out</div>
      </div>
    </div>
  </div>
</nav>

<ng-template #popContent>
  <table *ngIf="userService.userData">
    <tr>
      <td id="settings-username" class="username-email-section">{{ userService.userData.name }}</td>
    </tr>
    <tr>
      <td id="settings-email" class="username-email-section">{{ userService.userData.email }}</td>
    </tr>
  </table>
</ng-template>
